<template>
  <div class="approve-fail-list">
    <Modal
      v-model="show"
      :footer-hide="true"
      :closable="false"
      :width="1000"
      title="学校确认审批操作"
    >
      <div class="main" style="margin-bottom: 56px">
        <p style="margin-bottom: 16px">
          ①
          审批即表示对本次教师考勤的确认单确认无误，请根据实际情况进行审批操作。如果设置成通过发现确认单数据有误，请联系运营负责人进行驳回。
        </p>
        <p style="margin-bottom: 16px">
          ②
          <span class="color-red">未有结算账户</span
          >的教师确认单，审批通过时将自动设置成<span class="color-red"
            >已取消</span
          >，无法在本月完成正常打款，请于次月再核对处理打款。<span
            class="color-red font-bold"
            >请先于审批前确认教师结算账户信息。</span
          >
        </p>
        <p style="margin-bottom: 16px">
          待确认：<span
            class="color-red font-bold"
            style="margin-right: 16px"
            >{{ cfmCountNum.unconfirmedNum }}</span
          >
          已确认：<span class="font-bold" style="margin-right: 16px">{{
            cfmCountNum.confirmedNum
          }}</span>
          已取消：
          <span style="color: #f9a315" class="font-bold">{{
            cfmCountNum.abolishNum
          }}</span>
        </p>
        <RemarkCard>
          提示：执行学校确认后，将批量更新 待确认 的教师考勤为： 学校确认
          ，请仔细核对相关教师名单。
        </RemarkCard>
      </div>
      <div class="modal-430-bottom">
        <Button @click="handleCancle">取消</Button>
        <Button type="primary" @click="handleSubmit"
          >确认单无误，提交学校确认</Button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import RemarkCard from '@c/Base/RemarkCard.vue'
import financeCenterApi from '@/request/financeCenter/index.js'

export default {
  components: {
    RemarkCard
  },
  props: {
    cfmCountNum: {
      type: Object,
      default: () => {
        return {
          abolishNum: 0,
          confirmedNum: 0,
          schoolConfirmNum: 0,
          unconfirmedNum: 0
        }
      }
    },
    sheetId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      show: false,
      success: 0,
      failure: 0
    }
  },
  mounted() {

  },
  methods: {
    handleShow() {
      this.show = true
    },
    handleCancle() {
      this.show = false
    },
    handleSubmit() {
      this.setSchoolConfirmed()
    },
    async setSchoolConfirmed() {
      this.$Spin.show();
      let res = await financeCenterApi.setSchoolConfirmedApi({ sheetId: this.sheetId })
      this.$Spin.hide();
      if (res.status == 200) {
        this.success = res.message && res.message.success ? res.message.success : 0
        this.failure = res.message && res.message.failure ? res.message.failure : 0
        this.$Modal.success({
          title: '提交成功',
          content: `<p>校验成功通过：${this.success}    校验失败：${this.failure} </p>`
        });
        this.show = false
        this.$emit('on-finish')
      }
    }
  }
}
</script>

<style>
</style>